import { useId } from "react";

const ImgIcon = ({ width = 84, height = 81, ...props }) => {
  const uid = useId().replace(/:/g, "");
  const clipId = `img-icon-clip-${uid}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 84 81'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M20 1L46.5811 1L71 25.7236V73C71 76.866 67.866 80 64 80L20 80C16.134 80 13 76.866 13 73V8C13 4.13401 16.134 1 20 1Z'
          fill='#F3F6FA'
          stroke='#D5D9DF'
          strokeWidth='2'
        />
        <path
          d='M46 2.02502V20.325C46 23.6387 48.6863 26.325 52 26.325L70 26.325'
          stroke='#D5D9DF'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <rect x='3' y='39' width='48' height='32' rx='4' fill='#1440A8' />
      <path
        d='M13.274 48.9091V62L10.5063 62V48.9091L13.274 48.9091ZM15.5782 48.9091L18.9916 48.9091L22.5967 57.7045L22.7501 57.7045L26.3552 48.9091L29.7686 48.9091V62L27.0839 62V53.4794L26.9752 53.4794L23.5874 61.9361L21.7593 61.9361L18.3715 53.4474L18.2629 53.4474V62L15.5782 62V48.9091ZM40.7563 53.1406C40.6668 52.8295 40.5411 52.5547 40.3792 52.3161C40.2173 52.0732 40.0191 51.8686 39.7847 51.7024C39.5546 51.532 39.2904 51.402 38.9921 51.3125C38.6981 51.223 38.3721 51.1783 38.0141 51.1783C37.3451 51.1783 36.757 51.3445 36.2499 51.6768C35.7471 52.0092 35.355 52.4929 35.0738 53.1278C34.7925 53.7585 34.6519 54.5298 34.6519 55.4418C34.6519 56.3537 34.7904 57.1293 35.0674 57.7685C35.3444 58.4077 35.7364 58.8956 36.2435 59.2322C36.7506 59.5646 37.3494 59.7308 38.0397 59.7308C38.6661 59.7308 39.2009 59.62 39.6441 59.3984C40.0915 59.1726 40.4325 58.8551 40.6668 58.446C40.9055 58.0369 41.0248 57.5533 41.0248 56.995L41.5873 57.0781L38.2123 57.0781V54.9943L43.6903 54.9943V56.6435C43.6903 57.794 43.4474 58.7827 42.9616 59.6094C42.4758 60.4318 41.8067 61.0668 40.9545 61.5142C40.1022 61.9574 39.1263 62.179 38.0269 62.179C36.7996 62.179 35.7215 61.9084 34.7925 61.3672C33.8636 60.8217 33.1391 60.0483 32.6192 59.0469C32.1036 58.0412 31.8458 56.848 31.8458 55.4673C31.8458 54.4062 31.9992 53.4602 32.306 52.6293C32.6171 51.794 33.0518 51.0866 33.61 50.5071C34.1682 49.9276 34.8181 49.4865 35.5596 49.1839C36.3011 48.8814 37.1043 48.7301 37.9694 48.7301C38.7109 48.7301 39.4012 48.8388 40.0404 49.0561C40.6796 49.2692 41.2464 49.5717 41.7407 49.9638C42.2393 50.3558 42.6462 50.8224 42.9616 51.3636C43.2769 51.9006 43.4793 52.4929 43.5688 53.1406L40.7563 53.1406Z'
        fill='white'
      />
      <defs>
        <clipPath id={clipId}>
          <rect width='60' height='81' fill='white' transform='translate(12)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ImgIcon;
